import { ApiClient, ApiResp } from "../../api/ApiClient";
import { useContext, useEffect, useState, useRef } from "react";

import { Button, Form, Toast, Row, Descriptions } from "@douyinfe/semi-ui";

import { FormApi } from "@douyinfe/semi-ui/lib/es/form";

import "./visitSign.css";

let apiClient = ApiClient.getDefault();

interface LeadVisitSign {
  leadId: number;
  leadName: string;
  leadMobile: string;
  saleName: string;
}

export default function LeadVisitSignLog() {
  const [assignFormApi, setAssignFormApi] = useState(
    undefined as undefined | FormApi
  );
  const [saving, setSaving] = useState(false);
  const [signSuccess, setSignSuccess] = useState(false);
  const [leadVisitSign, setLeadVisitSign] = useState(
    undefined as undefined | LeadVisitSign
  );

  useEffect(() => {
    window.document.title = "上门登记";
    // let l = {
    //   leadName: "张三",
    //   leadMobile: "199999999",
    //   saleName: "李四",
    // } as LeadVisitSign;
    // setLeadVisitSign(l);
  }, []);

  const handleVisitSignClick = async () => {
    assignFormApi!
      .validate()
      .then(async (values) => {
        if (saving) {
          return;
        }

        setSaving(true);
        try {
          const apiResp: ApiResp<LeadVisitSign> = await apiClient.request(
            "/leadVisitSignLog",
            "POST",
            undefined,
            assignFormApi!.getValues()
          );
          setLeadVisitSign(apiResp.data);
          setSignSuccess(true);
          Toast.success({ content: "登记成功", duration: 10 });
          setSaving(false);
        } catch (e) {
          setSignSuccess(false);
          setSaving(false);
        }
      })
      .catch((errors) => {});
  };

  return (
    <section className="sign-section">
      <Form
        getFormApi={(formApi) => setAssignFormApi(formApi)}
        className="sign-form"
        style={{ display: signSuccess ? "none" : "" }}
      >
        <p className="sign-p">客户上门登记</p>
        <Row type="flex" justify="center">
          <Form.Input
            size="large"
            rules={[{ required: true, message: "请填写手机号" }]}
            className="sign-input"
            //placeholder={"请输入手机号"}
            field="mobile"
            label="手机号"
          ></Form.Input>
        </Row>
        <Row type="flex" justify="center">
          <Button
            onClick={handleVisitSignClick}
            htmlType="submit"
            className="sign-button"
          >
            登记
          </Button>
        </Row>
      </Form>

      <Descriptions
        className="sign-form"
        style={{ display: signSuccess ? "" : "none" }}
      >
        <p className="sign-p" style={{ color: "green" }}>
          登记成功！
        </p>
        <p style={{ color: "white", fontSize: "medium" }}>
          客户：{leadVisitSign?.leadName}
        </p>
        <p style={{ color: "white", fontSize: "medium" }}>
          手机号：{leadVisitSign?.leadMobile}
        </p>
        <p style={{ color: "white", fontSize: "medium" }}>
          顾问：{leadVisitSign?.saleName}
        </p>
      </Descriptions>
    </section>
  );
}
